/**
 * 生成1小时为间隔的时间段数据
 * @returns {Array<{value: string, label: string}>} 时间段数据数组
 */
export function generateHourlyTimeSlots(): Array<{ value: string, label: string }> {
  const timeSlots: Array<{ value: string, label: string }> = [];

  // 生成0-24小时的时间段
  for (let hour = 0; hour < 24; hour++) {
    // 格式化开始时间，确保两位数显示
    const startHour = hour.toString().padStart(2, '0');
    // 计算结束时间
    const endHour = (hour + 1).toString();
    // 创建时间段字符串
    const timeRange = `${startHour}:00-${endHour}:00`;

    // 添加到结果数组
    timeSlots.push({
      value: hour === 0 ? '24' : hour.toString(),
      label: timeRange
    });
  }

  return timeSlots;
}